import { Suspense, lazy, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { CompletePage } from './components/CompletePage';
import { DebugPanel } from './components/DebugPanel';
import { HomePage } from './components/HomePage';
import { InvitationPage } from './components/InvitationPage';
import { KnowledgePage } from './components/knowledge/KnowledgePage';
import { NotFoundPage } from './components/NotFoundPage';
import { SessionPage } from './components/SessionPage';
import { useVapi } from './hooks/useVapi';

// Dev-only fixture preview at /dev/bubbles. In production builds Vite
// substitutes `import.meta.env.DEV` to false, so the route is never
// registered and the lazy chunk is never fetched. (Rollup still emits the
// chunk file as orphan code — keeps the fixture out of the main bundle.)
const DevBubbleGallery = import.meta.env.DEV
  ? lazy(() =>
      import('./components/chat/ChatBubbleGallery').then((m) => ({
        default: m.ChatBubbleGallery,
      })),
    )
  : null;

function App() {
  const vapi = useVapi();
  const [activeCallId, setActiveCallId] = useState<string | null>(null);

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/session/:id"
          element={<SessionPage vapi={vapi} onCallIdChange={setActiveCallId} />}
        />
        <Route path="/interview/:invitationId" element={<InvitationPage />} />
        <Route path="/complete/:id" element={<CompletePage />} />
        <Route path="/knowledge" element={<KnowledgePage />} />
        {DevBubbleGallery && (
          <Route
            path="/dev/bubbles"
            element={
              <Suspense fallback={null}>
                <DevBubbleGallery />
              </Suspense>
            }
          />
        )}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <DebugPanel
        status={vapi.status}
        micPermission={vapi.micPermission}
        events={vapi.events}
        transcript={vapi.transcript}
        callId={activeCallId}
        onClear={() => setActiveCallId(null)}
      />
    </>
  );
}

export default App;
